export default {
  title: 'Kod promocyjny',
  fields: {
    preset: {
      label: 'Szablon',
    },
    presets: {
      master: 'Główny',
      campaign: 'Kampania',
      one_time: 'Jednorazowy',
    },
    code: {
      label: 'Kod',
      placeholder: 'Wprowadź kod',
    },
    discount_type: {
      label: 'Typ rabatu',
    },
    quantity: {
      label: 'Ilość',
      placeholder: 'Nieskończona',
    },
    expires_at: {
      label: 'Data wygaśnięcia',
      placeholder: 'Wprowadź datę lub pozostaw puste',
    },
    franchise: {
      label: 'Główny kod promocyjny dla restauracji i/lub całej marki',
    },
    discount: {
      label: 'Rabat',
    },
    usage_threshold: {
      label: 'Próg użycia',
    },
  },
  messages: {
    master_warning: 'Utworzenie nowego kodu „głównego" spowoduje wygaśnięcie obecnego głównego kodu',
  },
  buttons: {
    save: 'Zapisz',
    cancel: 'Anuluj',
  },
  toasts: {
    promo_code_got_created: 'Kod promocyjny został utworzony',
    promo_code_got_updated: 'Kod promocyjny został zaktualizowany',
  },
};
